module.exports = __webpack_public_path__ + "img/rule.0ff761db.svg";